import { useCallback, useContext } from 'react';
import AuthContext from './AuthContext';
export default function useAuth() {
    const { loggedIn, updateLoggedIn, requiresAuth } = useContext(AuthContext);
    const logOut = useCallback(() => {
        fetch('/signout', {
            method: 'GET'
        });
        updateLoggedIn(false);
    }, [updateLoggedIn]);
    const logIn = useCallback((token) => {
        updateLoggedIn(true, token);
    }, [updateLoggedIn]);
    return {
        requiresAuth,
        loggedIn,
        logOut,
        logIn
    };
}
//# sourceMappingURL=useAuth.js.map